import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import SettingsGridContainer from "../../components/SettingsGridContainer";

import {
  FaPercent,
  FaFileInvoice,
  FaAffiliatetheme,
} from "react-icons/fa";
import {
  MdCreditCard,
  MdAccountBalanceWallet,
  MdOutlineSupportAgent,
  MdOutlinePayment,
} from "react-icons/md";
import { IoStorefrontSharp } from "react-icons/io5";
import { AiOutlineTeam } from "react-icons/ai";
import { GrDomain } from "react-icons/gr";
import { ImWrench } from "react-icons/im";
import { TfiWorld } from "react-icons/tfi";
import { RiCoupon3Line } from "react-icons/ri";
import { BsQrCode } from "react-icons/bs";
import { FaGear } from "react-icons/fa6";
import { AppConfig } from "@/utils/AppConfig";
import { useUserRole } from "@/hooks/useUserRole";
import { ResturantData } from "@/types/globalTypes";
import {  useNavigate } from "react-router-dom";
import { navigateToSubscribtion } from "@/utils/helpers";


function Settings() {
  const { t } = useTranslation();
  const iconSize = AppConfig.IconSize.settingsCards;
  const { hasPermission } = useUserRole();
  const navigate = useNavigate();
  const token = useSelector(
  (state: { auth: { token: string } }) => state.auth.token,
);

  const ResturantData = useSelector(
    (state: { resturant: { resturantData: ResturantData } }) =>
      state.resturant.resturantData,
  );

  const WithoutPlan = ResturantData?.subscription === null;

  const settingsArray = [
    {
      icon: <FaGear size={iconSize} />,
      href: "/settings/general-settings",
      title: t("settingsCards.Settings.title"),
      description: t("settingsCards.Settings.description"),
      haveAccess: true,
      shouldShow: hasPermission("/settings/general-settings"),
      needSubscription: false,
    },
    {
      icon: <MdCreditCard size={iconSize} />,
      href: "/settings/payment-settings",
      title: t("settingsCards.paymentSettings.title"),
      description: t("settingsCards.paymentSettings.description"),
      haveAccess: true,
      shouldShow: hasPermission("/settings/payment-settings"),
      needSubscription: false,
    },
    {
      icon: <MdAccountBalanceWallet size={iconSize} />,
      href: "/settings/wallet-settings",
      title: t("settingsCards.wallet.title"),
      description: t("settingsCards.wallet.description"),
      haveAccess: true,
      shouldShow: hasPermission("/settings/wallet-settings"),
      needSubscription: false,
    },
    {
      icon: <ImWrench size={iconSize} />,
      href: "/settings/maintenance-settings",
      title: t("settingsCards.maintenance.title"),
      description: t("settingsCards.maintenance.description"),
      haveAccess: true,
      shouldShow: hasPermission("/settings/maintenance-settings"),
      needSubscription: false,
    },
    {
      icon: <GrDomain size={iconSize} />,
      href: "/settings/domain-settings",
      title: t("settingsCards.domain.title"),
      description: t("settingsCards.domain.description"),
      haveAccess: true,
      shouldShow: hasPermission("/settings/domain-settings"),
      needSubscription: false,
    },
    {
      icon: <IoStorefrontSharp size={iconSize} />,
      href: "/settings/branches-settings",
      title: t("settingsCards.branches.title"),
      description: t("settingsCards.branches.description"),
      haveAccess: true,
      shouldShow: hasPermission("/settings/branches-settings"),
      needSubscription: false,
    },
    {
      icon: <AiOutlineTeam size={iconSize} />,
      href: "/settings/permissions",
      title: t("settingsCards.employees.title"),
      description: t("settingsCards.employees.description"),
      haveAccess: !WithoutPlan,
      shouldShow: hasPermission("/settings/permissions"),
      needSubscription: true,
    },
    {
      icon: <FaAffiliatetheme size={iconSize} />,
      href: "/settings/theme",
      title: t("settingsCards.theme.title"),
      description: t("settingsCards.theme.description"),
      haveAccess: true,
      shouldShow: hasPermission("/settings/theme"),
      needSubscription: false,
    },
    {
      icon: <RiCoupon3Line size={iconSize} />,
      href: "/settings/coupons",
      title: t("settingsCards.coupons.title"),
      description: t("settingsCards.coupons.description"),
      haveAccess: true,
      shouldShow: hasPermission("/settings/coupons"),
      needSubscription: false,
    },
    {
      icon: <TfiWorld size={iconSize} />,
      href: "/settings/language-settings",
      title: t("settingsCards.languages.title"),
      description: t("settingsCards.languages.description"),
      haveAccess: true,
      shouldShow: hasPermission("/settings/language-settings"),
      needSubscription: false,
    },

    {
      icon: <FaPercent size={iconSize} />,
      href: "/settings/taxes-settings",
      title: t("settingsCards.tax.title"),
      description: t("settingsCards.tax.description"),
      haveAccess: true,
      shouldShow: hasPermission("/settings/taxes-settings"),
      needSubscription: false,
    },
    {
      icon: <BsQrCode size={iconSize} />,
      href: "/settings/qrcode-settings",
      title: t("settingsCards.qrcode.title"),
      description: t("settingsCards.qrcode.description"),
      haveAccess: true,
      shouldShow: hasPermission("/settings/qrcode-settings"),
      needSubscription: false,
    },
    {
      icon: <MdOutlinePayment size={iconSize} />,
      href: "/settings/subscribtion",
      title: t("settingsCards.subscription.title"),
      description: t("settingsCards.subscription.description"),
      haveAccess: true,
      shouldShow: hasPermission("/settings/subscribtion"),
      needSubscription: false,
      action : () => navigateToSubscribtion(navigate,token)
    },
    {
      icon: <FaFileInvoice size={iconSize} />,
      href: "/settings/terms-privacy",
      title: t("settingsCards.terms.title"),
      description: t("settingsCards.terms.description"),
      haveAccess: true,
      shouldShow: hasPermission("/settings/terms-privacy"),
      needSubscription: false,
    },
    {
      icon: <MdOutlineSupportAgent size={iconSize} />,
      href: "/settings/technical-support",
      title: t("settingsCards.support.title"),
      description: t("settingsCards.support.description"),
      haveAccess: true,
      shouldShow: hasPermission("/settings/technical-support"),
      needSubscription: false,
    },
  ];

  return (
    <div>
      <SettingsGridContainer title={t("settings")} cards={settingsArray} />
    </div>
  );
}

export default Settings;
